import * as React from 'react';
import { DropdownItem } from 'reactstrap';
import getClientEnvironment from '../../getClientEnvironment';
import {
    ConfirmDisconnectProps,
    withConfirmDisconnect
} from './withDisconnect';

// tslint:disable-next-line:no-submodule-imports
import * as faTimesCircle from '@fortawesome/fontawesome-free-solid/faTimesCircle';
import FontAwesomeIcon from '@fortawesome/react-fontawesome';

const config = getClientEnvironment();

const DisconnectDropdownItem = ({
    confirmDisconnect
}: ConfirmDisconnectProps) => (
    <DropdownItem color="danger" onClick={confirmDisconnect}>
        <FontAwesomeIcon icon={faTimesCircle} className="mr-2 text-danger" />
        Disconnect{' '}
        <span className="d-none d-lg-inline">{config.TITLE + ' '}</span>from
        Strava...
    </DropdownItem>
);

export default withConfirmDisconnect(DisconnectDropdownItem);



// WEBPACK FOOTER //
// ./src/client/components/Login/DisconnectDropdownItem.tsx